
import { defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import ProviderView from "@/components/ProviderView.vue";
import { addresses as localhost } from "@/utils/addresses/sample_localhost";
import { addresses as goerli } from "@/utils/addresses/sample_goerli";

const allAddresses: any = {
  localhost,
  goerli,
};

export default defineComponent({
  components: {
    ProviderView,
  },
  setup() {
    const route = useRoute();
    const network =
      typeof route.query.network == "string" ? route.query.network : "goerli";
    const addresses = allAddresses[network];
    const tokenAddress = addresses.sampleToken;
    console.log("*** chainId", network, tokenAddress);
    return {
      network,
      tokenAddress,
    };
  },
});
